import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import ReactOnRails from 'react-on-rails';

import AnonymousPartnerLandingApp from './AnonymousPartnerLandingApp';
import DemoAccountBanner from './demoAccountBannerApp';
import PremiumPricingGuideApp from './premiumPricingGuideApp';
import TeacherPremiumApp from './teacherPremiumApp';

import PreNavigationBanner from '../../Shared/components/shared/preNavigationBannerApp';
import StudentsOnlineNavbarButton from '../../Teacher/startup/StudentsOnlineNavbarButtonLazyClient';

import '../../../assets/javascripts/clickHandlers.js';
import '../../../../../vendor/assets/javascripts/jquery-1.8.2.js';
import '../../../../../vendor/assets/javascripts/bootstrap.js';
import '../../../assets/styles/home.scss';
import '../../Home/startup/accessible_video.js';
import '../../Home/startup/bootstrap_carousel.js';

import '../styles/anonymous_partner_landing.scss';
import '../../../../../app/assets/stylesheets/shared/modals.scss';

ReactOnRails.register({ AnonymousPartnerLandingApp, PremiumPricingGuideApp, DemoAccountBanner, TeacherPremiumApp, PreNavigationBanner, });

// Rendered by the shared teacher sub-header, so every ReactOnRails bundle must know it
ReactOnRails.register({ StudentsOnlineNavbarButton });
